module.exports = __webpack_public_path__ + "img/tahdir.3ca8e32e.png";